<div class="mobile-planner">
  @if (isUpdatingByUserInteraction) {
      <div class="mobile-planner__fast-update">
          <img ngSrc="assets/svg/circles.svg" width="100" height="100" alt="loading">
          <p>Updating itinerary</p>
      </div>
  }

  @if ([ETripPlannerView.PLANNER_OVERVIEW, ETripPlannerView.HOTEL_BOX].includes(plannerView)) {
    <div class="mobile-planner__header">
      <app-switcher
        [isDynamicWidth]="true"
        [selectedIndex]="0"
        [switcherConfig]="[
                      { label: 'My Plan', parameter: eRoutes.TRIP_PLANNER },
                      { label: 'AI Chat', parameter: eRoutes.AI_CHAT },
                      { label: 'Popular Itineraries', parameter: eRoutes.TRIP_POPULAR_ITINERARIES },
        ]"
        [changeSelectedIndexFromParent]="selectedTabViewIndex"
        (selectedSwitch)="selectedTabView = $event"
      >
      </app-switcher>
    </div>
  }

  <div class="mobile-planner__content">
    @switch (selectedTabView) {
      @case (eRoutes.TRIP_PLANNER) {
        @switch (plannerView) {
          @case (ETripPlannerView.PLANNER_OVERVIEW) {
            <div class="mobile-planner__content__tab">
              <div class="mobile-planner__map">
                @if (isCreateTripFetching) {
                  <ngx-skeleton-loader [theme]="{height: '100%', width: '100%', margin: '0'}"></ngx-skeleton-loader>
                } @else {
                  @if (destinationsRoute && destinationsRoute.length) {
                    <app-preview-map
                      [savedTripView]="true"
                      [destinationsRoute]="destinationsRoute"
                      (tripLegs)="setParsedTripLegs($event)"
                    ></app-preview-map>
                  }
                }

                <div class="mobile-planner__toggles">
                  <div class="optimize-toggle-box">
                    <span>{{trip.isOptimizedMode ? 'Optimizer' : 'Manual'}}</span>
                    <mat-slide-toggle
                      [hideIcon]="true"
                      [checked]="trip.isOptimizedMode"
                      (change)="togglePlanningModeHandler($event)"
                    ></mat-slide-toggle>
                  </div>
                  @if (!showPreferences) {
                    <button
                      mat-ripple
                      class="preferences-toggle-btn"
                      (click)="showPreferences = true"
                      [disabled]="!trip.isOptimizedMode"
                    >
                      <mat-icon [svgIcon]="eSvgIcons.M_SETTINGS"></mat-icon>
                    </button>
                  }
                </div>
              </div>
              <div class="mobile-planner__panel-overview">
                @if (!showPreferences) {
                  <div #controlBox class="mobile-planner__destinations-control">
                    <div class="mobile-planner__destinations-control__p-type">
                      {{ planningTypeText }}
                    </div>
                    <h1 class="mobile-planner__destinations-control__name">
                      @if(isCreateTripFetching) {
                        <ngx-skeleton-loader [theme]="{height: '20px', width: '200px', margin: '5px 0 0', display: 'inline-block'}"></ngx-skeleton-loader>
                      } @else {
                        {{ correctTripName }}
                      }
                    </h1>
                    @if (trip.plannerInfo && trip.plannerInfo.type === 'popular') {
                      <p class="mobile-planner__destinations-control__description">
                        {{ trip.plannerInfo.description }}
                      </p>
                    }
                    <div class="mobile-planner__destinations-control__actions">
                      <button (click)="openAddDestinationDialog()" [disabled]="isCreateTripFetching">
                        <mat-icon [svgIcon]="eSvgIcons.IC_PLUS"></mat-icon>
                        Add destination
                      </button>
                      @if (!userId) {
                        <span class="vl-separator"></span>
                        <button (click)="saveTripHandler()" [disabled]="isCreateTripFetching">
                          <mat-icon [svgIcon]="eSvgIcons.IC_M_SAVE"></mat-icon>
                          Save
                        </button>
                      }
                      <span class="vl-separator"></span>
                      <button [matMenuTriggerFor]="actionsMenu" [disabled]="isCreateTripFetching">
                        <mat-icon [svgIcon]="eSvgIcons.IC_M_MORE"></mat-icon>
                        More
                      </button>
                      <mat-menu #actionsMenu="matMenu" xPosition="before">
                        <button mat-menu-item
                                (click)="handleUndo()"
                                [disabled]="tripWizardStateService.isUndoDisabled || isCreateTripFetching">
                          <img class="m-item-icon"
                               ngSrc="assets/svg/ic-undo.svg"
                               width="16"
                               height="16"
                               alt="undo"
                          />
                          Undo
                        </button>
                        <button mat-menu-item
                                (click)="handleRedo()"
                                [disabled]="tripWizardStateService.isRedoDisabled || isCreateTripFetching">
                          <img class="m-item-icon"
                               ngSrc="assets/svg/ic-redo.svg"
                               width="16"
                               height="16"
                               alt="redo"
                          />
                          Redo
                        </button>
                        <button mat-menu-item (click)="openRenameTripDialog()" [disabled]="isCreateTripFetching">
                          <img class="m-item-icon"
                               ngSrc="assets/svg/ic-mode-edit.svg"
                               width="16"
                               height="16"
                               alt="edit"
                          />
                          Rename
                        </button>
                        <button mat-menu-item (click)="printElementRef.tripPlanPrint()" [disabled]="isCreateTripFetching">
                          <img class="m-item-icon"
                               ngSrc="assets/svg/ic-print.svg"
                               width="16"
                               height="16"
                               alt="print"
                          />
                          Print
                        </button>
                      </mat-menu>
                    </div>
                  </div>
                  @if (createdTrip || isCreateTripFetching) {
                    @if(isCreateTripFetching) {
                      <div class="mobile-planner__destinations-list"
                           [style.--extra-height.px]="controlBox.offsetHeight"
                      >
                        <app-trip-destinations-list
                          [isFetching]="true"
                        ></app-trip-destinations-list>

                        <div class="mobile-planner__inspired">
                          <h1 class="mobile-planner__inspired--title">Get inspired</h1>
                          <section class="mobile-planner__inspired--section">
                            <app-itinerary-list-mobile
                              [title]="'Popular Trips'"
                              [isFetching]="isTripsFetching"
                              [itineraries]="topTips"
                              (makeItMyPlan)="onMakeItMyTripPlanHandler(0)"
                              (onSeeAll)="onSeeAllPopularTripsHandler()"
                            ></app-itinerary-list-mobile>
                          </section>

                          <section class="mobile-planner__inspired--section">
                            <app-occasion-genius
                              [title]="'Event Calendar'"
                              [cityId]="createdTrip?.destinations[0]?.id"
                              [cityName]="createdTrip?.destinations[0]?.cityName"
                              [countryName]="createdTrip?.destinations[0]?.countryName"
                              [isFetching]="isOccasionGeniusFetching"
                              [occasionGeniusResponse]="occasionGeniusResponse"
                              [eventsSearchedAndSorted]="occasionGeniusResponse.eventsSearchedAndSorted"
                            ></app-occasion-genius>
                          </section>
                        </div>
                      </div>
                    } @else {
                      <div #overviewEl
                           cdkScrollable
                           class="mobile-planner__destinations-list"
                           [style.--extra-height.px]="controlBox.offsetHeight"
                      >
                        <app-trip-destinations-list
                          [legs]="legs"
                          [plannerView]="plannerView"
                          [isFetching]="false"
                          [isSpecifyDates]="trip.isSpecifyDates"
                          [isOptimizedMode]="trip.isOptimizedMode"
                          [destinations]="createdTrip.destinations"
                          [packages]="packageResponse?.results || []"
                          [cityInfoIndex]="cityInfoIndex"
                          (onSelectTrip)="handleChangeTrip($event)"
                          (changeDestinationDuration)="changeDestinationDurationHandler($event)"
                          (onLockOrUnlockDestination)="toggleLockDestinationHandler($event)"
                          (changeDestination)="changeDestinationHandler($event)"
                          (removeDestination)="removeDestinationHandler($event)"
                          (toggleDestinationsChanges)="changeDestinationsHandler()"
                          (onScrollToElement)="onScrollToElementHandler($event)"
                        ></app-trip-destinations-list>

                        <div class="mobile-planner__inspired">
                          <h1 class="mobile-planner__inspired--title">Get inspired</h1>
                          <section class="mobile-planner__inspired--section">
                            <app-itinerary-list-mobile
                              [title]="'Popular Trips'"
                              [isFetching]="isTripsFetching"
                              [itineraries]="topTips"
                              (makeItMyPlan)="onMakeItMyTripPlanHandler(0)"
                              (onSeeAll)="onSeeAllPopularTripsHandler()"
                            ></app-itinerary-list-mobile>
                          </section>

                          <section class="mobile-planner__inspired--section">
                            <app-occasion-genius
                              [title]="'Event Calendar'"
                              [cityId]="createdTrip?.destinations[0]?.id"
                              [cityName]="createdTrip?.destinations[0]?.cityName"
                              [countryName]="createdTrip?.destinations[0]?.countryName"
                              [isFetching]="isOccasionGeniusFetching"
                              [occasionGeniusResponse]="occasionGeniusResponse"
                              [eventsSearchedAndSorted]="occasionGeniusResponse.eventsSearchedAndSorted"
                            ></app-occasion-genius>
                          </section>
                        </div>
                      </div>
                    }
                  }
                } @else {
                  <app-trip-preferences
                    [showTripPreferences]="true"
                    (buttonEvent)="showPreferences = false"
                    (sliderEvent)="changeTripPreferencesHandler()"
                  ></app-trip-preferences>
                }
              </div>
            </div>
          }
          @case (ETripPlannerView.CITY_OVERVIEW) {
            <div class="mobile-planner__services-info" (scroll)="$event.preventDefault()">
              @if (createdTrip && createdTrip.destinations; as destinations) {
                <app-trip-city-info
                  [destinations]="destinations"
                  [cityInfoIndex]="cityInfoIndex"
                  [legs]="legs"
                  [trip]="trip"
                  [packages]="packageService.packages$ | async"
                  (onCityIndexChange)="cityInfoIndex = $event"
                ></app-trip-city-info>
              }
            </div>
          }
          @case (ETripPlannerView.CAR_RENTAL_BOX) {
            <div class="mobile-planner__services-info mobile-planner__services-info--padding">
              <h4 class="mobile-planner__services-info__title">Car Rental</h4>
              @if (carRentalQuery) {
                <app-car-rental-preview
                  [currencyCode]="apiSettingsService.currency"
                  [query]="carRentalQuery"
                ></app-car-rental-preview>
              }
            </div>
          }
          @case (ETripPlannerView.FLIGHTS_BOX) {
            <div class="mobile-planner__services-info mobile-planner__services-info--padding">
              <h4 class="mobile-planner__services-info__title">Flights</h4>
              @if (createdTrip && createdTrip.destinations; as destinations) {
                <app-book-flights-link
                  [itineraryItem]="destinations[0]"
                ></app-book-flights-link>
              }
            </div>
          }
        }
        <div class="mobile-planner__navigation">
          <div class="mobile-planner__navigation__container">
            <button (click)="onServicesViewHandler(ETripPlannerView.PLANNER_OVERVIEW)">
              <mat-icon [svgIcon]="[ETripPlannerView.PLANNER_OVERVIEW, ETripPlannerView.CITY_OVERVIEW].includes(plannerView)
                            ? eSvgIcons.M_MAP_FILLED
                            : eSvgIcons.M_MAP"
              ></mat-icon>
            </button>
            <button (click)="onServicesViewHandler(ETripPlannerView.PLANNER_OVERVIEW); showFirstCityHotels()">
              <mat-icon [svgIcon]="eSvgIcons.M_BED"
              ></mat-icon>
            </button>
            <button (click)="onServicesViewHandler(ETripPlannerView.CAR_RENTAL_BOX)">
              <mat-icon [svgIcon]="plannerView === ETripPlannerView.CAR_RENTAL_BOX
                            ? eSvgIcons.M_CAR_FILLED
                            : eSvgIcons.M_CAR"
              ></mat-icon>
            </button>
            <button (click)="onServicesViewHandler(ETripPlannerView.FLIGHTS_BOX)">
              <mat-icon [svgIcon]="plannerView === ETripPlannerView.FLIGHTS_BOX
                            ? eSvgIcons.M_PLANE_FILLED
                            : eSvgIcons.M_PLANE"
              ></mat-icon>
            </button>
            <button class="favorite-btn" (click)="goToWishlistHandler()">
              <span class="favorite-btn__count">{{ favoritesAmount }}</span>
              <mat-icon [svgIcon]="eSvgIcons.M_HEART"></mat-icon>
            </button>
          </div>
        </div>
      }
      @case (eRoutes.AI_CHAT) {
        <div class="mobile-planner__content__tab ai-chat">
          <app-ai-chat-mobile
            #aiChatMobileComponent
            [aiChatInputMobileComponent]="aiChatInputMobileComponent"
            (backToPlannerOverview)="onMakeItMyTripPlanHandler(0)"
          ></app-ai-chat-mobile>
        </div>
        <div class="mobile-planner__chat-input">
          <app-ai-chat-input-mobile
            #aiChatInputMobileComponent
            [aiChatMobileComponent]="aiChatMobileComponent"
          ></app-ai-chat-input-mobile>
        </div>
      }
      @case (eRoutes.TRIP_POPULAR_ITINERARIES) {
        <div class="mobile-planner__content__tab">
          <app-itinerary-list-mobile
            [isVertical]="true"
            [itineraries]="topTips"
            [isFetching]="isTripsFetching"
            (makeItMyPlan)="onMakeItMyTripPlanHandler(0)"
          ></app-itinerary-list-mobile>
        </div>
      }
    }
  </div>
</div>

<app-trip-plan-print
  #printElementRef
  [tripName]="trip?.name || createdTrip?.name"
  [itineraryItems]="createdTrip?.destinations"
></app-trip-plan-print>
